<template>
  <div class="panel-in-tab store-plan-config" :style="{ height: (maxTableHeight + 86) + 'px' }">
    <div style="height: 10px"></div>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button
          :type="editStatus ? 'warning' : 'primary'"
          size="mini"
          @click="edit"
        >{{ editStatus ? "保存" : "编辑" }}</el-button>
        <el-button type="primary" size="mini" @click="cancel" v-if="editStatus">取消</el-button>
      </template>
      <div v-loading="loading">
        <el-form :model="form" :inline="true" size="mini" label-width="120px">
          <div style="padding: 20px 10px">
            <el-row type="flex">
              <el-col>
                <el-form-item label="主图下载公告:">
                  <el-input
                    type="textarea"
                    :rows="clientWidth == '1920' ? 10 : 8"
                    :maxlength="200"
                    :disabled="!editStatus"
                    show-word-limit
                    placeholder="请输入内容"
                    v-model.trim="form.mainPhoto"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="微详情下载公告:">
                  <el-input
                    type="textarea"
                    :rows="clientWidth == '1920' ? 10 : 8"
                    :maxlength="200"
                    :disabled="!editStatus"
                    show-word-limit
                    placeholder="请输入内容"
                    v-model.trim="form.microDetail"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="抖快下载公告:">
                  <el-input
                    type="textarea"
                    :rows="clientWidth == '1920' ? 10 : 8"
                    :maxlength="200"
                    :disabled="!editStatus"
                    show-word-limit
                    placeholder="请输入内容"
                    v-model.trim="form.tikQuick"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="猜喜下载公告:">
                  <el-input
                    type="textarea"
                    :rows="clientWidth == '1920' ? 10 : 8"
                    :maxlength="200"
                    :disabled="!editStatus"
                    show-word-limit
                    placeholder="请输入内容"
                    v-model.trim="form.surmiseFond"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="其他下载公告:">
                  <el-input
                    type="textarea"
                    :rows="clientWidth == '1920' ? 10 : 8"
                    :maxlength="200"
                    :disabled="!editStatus"
                    show-word-limit
                    placeholder="请输入内容"
                    v-model.trim="form.other"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';

export default {
  mixins: [tableMixin],
  data() {
    return {
      form: {},
      editStatus: false,
      loading: false,
    };
  },
  computed: {
    clientWidth() {
      return document.body.clientWidth;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    edit() {
      this.editStatus = !this.editStatus;
      if (!this.editStatus) {
        let data = {
          ...this.form,
        };
        this.$q.shortVideoOverview
          .bulletinUpdate({ data: data })
          .then((res) => {
            this.form = res.data;
            this.$message.success('编辑成功');
            this.init();
          })
          .catch((res) => {
            this.editStatus = true;
          });
      }
    },
    cancel() {
      this.editStatus = false;
      this.init();
    },
    async init() {
      this.loading = true;
      let res = await this.$q.shortVideoOverview.BulletinSeach();
      if (res.success && res.data) {
        this.form = res.data;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

.store-plan-config
  overflow-y auto

  >>> .main-area
    height 100%
    overflow visible

>>> .el-form-item
  width 100%

>>> .el-textarea
  width calc(100% - 120px)

>>> .el-form-item__content
  width calc(100% - 120px)

>>> .el-textarea.is-disabled .el-textarea__inner
  color #606266 !important
  background-color #ffffff !important

>>> .el-textarea__inner
  resize none
</style>
